// _neu_generated_code__dont_modify_directly_
import { NeutrinosAuthGuardService } from 'neutrinos-oauth-client';
import { PageNotFoundComponent } from '../not-found.component';
import { LayoutComponent } from '../layout/layout.component';
import { ImgSrcDirective } from '../directives/imgSrc.directive';
import { APP_INITIALIZER } from '@angular/core';
import { NDataSourceService } from '../n-services/n-dataSorce.service';
import { environment } from '../../environments/environment';
import { NLocaleResource } from '../n-services/n-localeResources.service';
import { NAuthGuardService } from 'neutrinos-seed-services';
import { ArtImgSrcDirective } from '../directives/artImgSrc.directive';
import { localesService } from '../../../baseClasses/localesService';

window['neutrinos'] = {
  environments: environment,
};

//CORE_REFERENCE_IMPORTS
//CORE_REFERENCE_IMPORT-memberSelectModalComponent
import { memberSelectModalComponent } from '../components/components/memberSelectModal.component';
//CORE_REFERENCE_IMPORT-DataService
import { DataService } from '../sd-services/DataService';
//CORE_REFERENCE_IMPORT-authinterceptorService
import { authinterceptorService } from '../services/authinterceptor/authinterceptor.service';
//CORE_REFERENCE_IMPORT-backenddataService
import { backenddataService } from '../services/backenddata/backenddata.service';
//CORE_REFERENCE_IMPORT-processLogComponent
import { processLogComponent } from '../components/pages/processLog.component';
//CORE_REFERENCE_IMPORT-searchDetailsComponent
import { searchDetailsComponent } from '../components/pages/searchDetails.component';
//CORE_REFERENCE_IMPORT-mvrReportCardComponent
import { mvrReportCardComponent } from '../components/components/mvrReportCard.component';
//CORE_REFERENCE_IMPORT-carfaxReportCardComponent
import { carfaxReportCardComponent } from '../components/components/carfaxReportCard.component';
//CORE_REFERENCE_IMPORT-prefillReportCardComponent
import { prefillReportCardComponent } from '../components/components/prefillReportCard.component';
//CORE_REFERENCE_IMPORT-clueReportCardComponent
import { clueReportCardComponent } from '../components/components/clueReportCard.component';
//CORE_REFERENCE_IMPORT-creditReportCardComponent
import { creditReportCardComponent } from '../components/components/creditReportCard.component';
//CORE_REFERENCE_IMPORT-reportSummaryComponent
import { reportSummaryComponent } from '../components/pages/reportSummary.component';
//CORE_REFERENCE_IMPORT-sideNavComponent
import { sideNavComponent } from '../components/components/sideNav.component';
//CORE_REFERENCE_IMPORT-authComponent
import { authComponent } from '../components/layout/auth.component';
//CORE_REFERENCE_IMPORT-homeComponent
import { homeComponent } from '../components/layout/home.component';
//CORE_REFERENCE_IMPORT-getDetailsComponent
import { getDetailsComponent } from '../components/pages/getDetails.component';

/**
 * Reads datasource object and injects the datasource object into window object
 * Injects the imported environment object into the window object
 *
 */
export function startupServiceFactory(startupService: NDataSourceService) {
  return () => {
    return new Promise((resolve, reject) => {
      startupService.getDataSource().then(() => {
        localesService.init().then(() => {
          resolve(null);
        });
      });
    });
  };
}

/**
 *bootstrap for @NgModule
 */
export const appBootstrap: any = [LayoutComponent];

/**
 *declarations for @NgModule
 */
export const appDeclarations = [
  ImgSrcDirective,
  LayoutComponent,
  PageNotFoundComponent,
  ArtImgSrcDirective,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-memberSelectModalComponent
  memberSelectModalComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-processLogComponent
  processLogComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-searchDetailsComponent
  searchDetailsComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-mvrReportCardComponent
  mvrReportCardComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-carfaxReportCardComponent
  carfaxReportCardComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-prefillReportCardComponent
  prefillReportCardComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-clueReportCardComponent
  clueReportCardComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-creditReportCardComponent
  creditReportCardComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-reportSummaryComponent
  reportSummaryComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-sideNavComponent
  sideNavComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-authComponent
  authComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-homeComponent
  homeComponent,
  //CORE_REFERENCE_PUSH_TO_DEC_ARRAY-getDetailsComponent
  getDetailsComponent,
];

/**
 * provider for @NgModule
 */
export const appProviders = [
  NDataSourceService,
  NLocaleResource,
  {
    // Provider for APP_INITIALIZER
    provide: APP_INITIALIZER,
    useFactory: startupServiceFactory,
    deps: [NDataSourceService],
    multi: true,
  },
  NAuthGuardService,
  //CORE_REFERENCE_PUSH_TO_PRO_ARRAY
  //CORE_REFERENCE_PUSH_TO_PRO_ARRAY-DataService
  DataService,
  //CORE_REFERENCE_PUSH_TO_PRO_ARRAY-authinterceptorService
  authinterceptorService,
  //CORE_REFERENCE_PUSH_TO_PRO_ARRAY-backenddataService
  backenddataService,
];

/**
 * Routes available for bApp
 */

// CORE_REFERENCE_PUSH_TO_ROUTE_ARRAY_START
export const appRoutes = [
  {
    path: 'home',
    component: homeComponent,
    children: [
      { path: 'get-details', component: getDetailsComponent },
      { path: 'report-summary', component: reportSummaryComponent },
      { path: 'search-report', component: searchDetailsComponent },
      { path: 'process-log', component: processLogComponent },
    ],
  },
  { path: 'auth', component: authComponent },
  { path: '', redirectTo: '/home/get-details', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
];
// CORE_REFERENCE_PUSH_TO_ROUTE_ARRAY_END
